import React from "react";
import { Tag } from "antd";
import { CompanyStatus } from "@/utils/enum";
import {
  statusToString,
  statusToColorBackground,
  statusToColorBorder,
  statusToColorText,
} from "@/components/EntityFlagToggle";

const getTagStyle = status => ({
  color: statusToColorText[status],
  borderColor: statusToColorBorder[status],
  marginLeft: "5%",
  maxHeight: 25,
  ...(status === CompanyStatus.Active && { display: "none" }),
});

const EntityFlagTag = ({ flagStatus }) => {
  return (
    <Tag color={statusToColorBackground[flagStatus]} style={getTagStyle(flagStatus)}>
      {statusToString[flagStatus]}
    </Tag>
  );
};

export default EntityFlagTag;
